import { type RemoteApiSpec } from "../../../../gql-generated/types";

export enum SortBy {
    Name,
    Date,
}

export enum SortDirection {
    Asc,
    Desc,
    Unset,
}

export const onSortHelper = (
    sortBy: SortBy,
    sortDirection: SortDirection,
    apis: readonly RemoteApiSpec[],
): readonly RemoteApiSpec[] => {
    const sortedApis = [...apis];

    if (sortBy === SortBy.Name) {
        if (sortDirection === SortDirection.Asc) {
            return sortedApis.sort((apiA: RemoteApiSpec, apiB: RemoteApiSpec) => {
                return apiA.name.localeCompare(apiB.name);
            });
        } else if (sortDirection === SortDirection.Desc) {
            return sortedApis.sort((apiA: RemoteApiSpec, apiB: RemoteApiSpec) => {
                return apiB.name.localeCompare(apiA.name);
            });
        } else {
            return sortedApis;
        }
    } else {
        if (sortDirection === SortDirection.Asc) {
            return sortedApis.sort((apiA: RemoteApiSpec, apiB: RemoteApiSpec) => {
                const updatedAtA = new Date(apiA.updatedAt);
                const updatedAtB = new Date(apiB.updatedAt);
                return updatedAtA.getTime() - updatedAtB.getTime();
            });
        } else if (sortDirection === SortDirection.Desc) {
            return sortedApis.sort((apiA: RemoteApiSpec, apiB: RemoteApiSpec) => {
                const updatedAtA = new Date(apiA.updatedAt);
                const updatedAtB = new Date(apiB.updatedAt);
                return updatedAtB.getTime() - updatedAtA.getTime();
            });
        } else {
            return sortedApis;
        }
    }
};
